<template>
    <div>
        <XjdTop :isfixed="false"></XjdTop>
        <div class="contet" v-loading="loading">
            <div class="dh">
                <el-breadcrumb separator="/">
                    <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
                    <el-breadcrumb-item><a href="/gydetail">供应商详情</a></el-breadcrumb-item>
                </el-breadcrumb>
            </div>
            <div class="citem">
                <div class="c_l">
                    <div class="text_s">
                        <div class="gname">{{ userinfo.nickname }} <span>{{ userinfo.p_score }}</span></div>
                        <div class="tagflex">
                            <div class="titem i2" v-if="userinfo.is_penyin == 2">喷绘</div>
                            <!-- 是否包邮：0=否，是 -->
                            <div class="titem i3" v-if="userinfo.is_free == 1">包邮</div>
                        </div>
                        <div class="dw">
                            <img src="@/assets/dw.png" alt="" srcset="">
                            {{ userinfo.province }}/{{ userinfo.city }}/{{ userinfo.area }}
                        </div>
                        <div class="js">
                            业务介绍：{{ userinfo.zyyw_content }}
                        </div>
                        <div class="js">
                            公告：{{ userinfo.gg_content }}
                        </div>
                        <!-- <div class="wl">
                            <div class="wl_l">
                                支持物流：
                                <div class="items" v-for="(item, index) in userinfo.logistics_names" :key="index">
                                    <div v-if="index < 10" style="margin-right: 6px;">{{ item }}</div>
                                </div>
                            </div>
                            <div class="open" @click="openAllcity">查看全部</div>
                        </div> -->
                    </div>
                </div>

                <div class="c_r" @click="openkf">
                    <div class="btn">
                        <div style="display: flex;  align-items: center;">
                            <img src="../assets/bigxx.png" alt="">
                            在线咨询
                        </div>
                    </div>
                    <div class="btexts">
                        点击在线咨询，了解更多详情信息
                    </div>
                </div>
            </div>
            <div class="conten_z">

                <div class="titl">
                    <div @click="indexs = 1">
                        <div class="items" :class="indexs == 1 ? 'active' : ''">详情介绍</div>
                        <div class="x" v-if="indexs == 1"></div>
                    </div>
                    <div @click="indexs = 2">
                        <div class="items" :class="indexs == 2 ? 'active' : ''">收费标准</div>
                        <div class="x" v-if="indexs == 2"></div>
                    </div>
                </div>
                <div class="c_neir" v-if="indexs == 1" v-html="userinfo.company_content">
                </div>
                <div class="c_neir" v-if="indexs == 2" v-html="userinfo.sfbz_content">
                </div>
            </div>
        </div>
        <div class="bcg">
            <el-carousel height="200px" :interval="5000">
                <el-carousel-item v-for="(item, index) in bannerList" :key="index">
                    <img :src="item.image" alt="" style="width: 100%;" @click="gourl(item)">
                </el-carousel-item>
            </el-carousel>
        </div>
        <div class="content_list">
            <div class="title">
                <div class="x"></div>
                <div class="tt">为你推荐</div>
                <div class="x"></div>
            </div>
            <div class="citem" v-for="(item, index) in SupplierList" :key="index" @click="godetail(item)">
                <div class="c_l">
                    <div>
                        <el-image style="width: 120px; height: 120px;border-radius:6px" :src="item.avatar"></el-image>
                    </div>
                    <div class="text_s">
                        <div class="gname">{{ item.nickname }} <span>{{ item.p_score }}</span></div>
                        <div class="tagflex">
                            <div class="titem i1">IP：{{ item.city }}</div>
                            <!-- 是否喷印:1=否,2=是 -->
                            <div class="titem i2" v-if="item.is_penyin == 2">喷绘</div>
                            <!-- 是否包邮：0=否，是 -->
                            <div class="titem i3" v-if="item.is_free == 1">包邮</div>
                        </div>
                        <div class="js">
                            业务介绍：{{ item.zyyw_content ? item.zyyw_content : '暂无填写' }}
                        </div>
                        <div class="wl">
                            支持物流：
                            <div v-if="item.logistics_names.length == 0">暂无填写</div>
                            <div v-else class="wl">
                                <div class="items" v-for="(item, index) in item.logistics_names" :key="index">
                                    <span v-if="index < 10">{{ item }}</span>
                                </div>
                            </div>
                            <div v-if="item.logistics_names.length != 0" class="btn" @click.stop="openAllcitys(item)">
                                查看全部</div>
                        </div>
                    </div>
                </div>
                <div class="c_r">
                    <div class="rig_icon">
                        <img v-if="item.is_collect == 1" src="../assets/tim/q.png" alt=""
                            @click.stop="handlerHaoyou(item, 1)">
                        <img v-else src="../assets/tim/j.png" alt="" @click.stop="handlerHaoyou(item, 2)">
                    </div>
                    <div class="btn z_btn" @click.stop="openTim(item)">
                        <div style="display: flex;align-items: center;">
                            <img src="../assets/xx.png" alt="">
                            在线咨询
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <el-dialog title="物流信息" width="620px" class="icon-dialog" :visible.sync="popup.ischeckpop" append-to-body
            @close="close">
            <div class="dialogs check">
                <div class="items" v-for="(item, index) in popup.clist" :key="index">
                    {{ item }}
                </div>
            </div>
        </el-dialog>
        <el-dialog class="dialogs" :visible.sync="showTim" width="1120px">
            <TimView v-if="showTim" :chatID="chatID" :openNum="openNum" @close="closeTim"></TimView>
        </el-dialog>
        <Xjdbottom></Xjdbottom>
    </div>
</template>

<script>
import XjdTop from '../components/XjdTop'
import Xjdbottom from '../components/Xjdbottom'
import TimView from '@/components/TimView/index.vue'
import { getSupplierDetail, getSupplierList, getBanner, jhaoyou, shaoyou } from '@/api/index.js'
export default {
    components: {
        XjdTop, Xjdbottom, TimView
    },
    name: '',
    data() {
        return {
            indexs: 1,
            userinfo: {},
            popup: {
                ischeckpop: false,
                clist: []
            },
            loading: false,
            SupplierList: [],
            showTim: false,
            chatID: '',
            bannerList: []

        }
    },
    computed: {
        isMobile() {
            let flag = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)
            return flag;
        },
    },
    mounted() {
        //轮播图
        getBanner({ position_type: 2 }).then(res => {
            this.bannerList = res.data
        })
        this.gotop()
        this.loading = true
        getSupplierDetail({ supplier_id: this.$route.query.id }).then(res => {
            if (res.code == 1) {
                this.userinfo = res.data
                this.loading = false
            } else {
                this.loading = false
            }
        })
        getSupplierList().then(res => {
            this.SupplierList = res.data.list.slice(0, 2)
        })
    },
    methods: {
        handlerHaoyou(item, type) {
            let userID = 'xj' + item.id
            let userIDh = item.id
            let that = this
            if (type == 1) {
                let promise = that.tim.deleteFriend({
                    userIDList: [userID],
                    type: that.TIM.TYPES.SNS_DELETE_TYPE_BOTH
                });
                promise.then(function (imResponse) {
                    that.nowUserInfo = {}
                    that.ishaoyou = false
                    shaoyou({ collect_id: userIDh }).then(res => {
                        getSupplierList().then(res => {
                            that.SupplierList = res.data.list.slice(0, 2)
                        })
                    })
                }).catch(function (imError) {
                    console.warn('removeFromFriendList error:', imError);
                });

            } else {
                let promise = that.tim.addFriend({
                    to: userID,
                    source: 'AddSource_Type_Web',
                    type: that.TIM.TYPES.SNS_ADD_TYPE_SINGLE
                });
                promise.then(function (imResponse) {
                    that.ishaoyou = true
                    jhaoyou({ collected_id: userIDh }).then(res => {
                        getSupplierList().then(res => {
                            that.SupplierList = res.data.list.slice(0, 2)
                        })
                    })
                }).catch(function (imError) {
                    console.warn('removeFromFriendList error:', imError);
                });
            }
        },
        gourl(item) {
            if (item.url_path) {
                window.open(item.url_path, '_blank')
            }
        },
        //查看详情
        godetail(item) {
            this.gotop()
            this.loading = true
            getSupplierDetail({ supplier_id: item.id }).then(res => {
                if (res.code == 1) {
                    this.userinfo = res.data
                    this.loading = false
                } else {
                    this.loading = false
                }
            })
        },
        gotop() {
            document.body.scrollTop = 0;
            document.documentElement.scrollTop = 0;
            // 兼容IE
            window.scrollTo(0, 0);
        },
        openkf() {
            if (this.isMobile) {
                this.$dataConver.gopage(this.userinfo.id)
                return
            }
            this.openNum = 1
            this.chatID = this.userinfo.id
            this.showTim = true
        },
        openTim(item) {
            if (this.isMobile) {
                this.$dataConver.gopage(item.id)
                return
            }
            this.openNum = 1
            this.chatID = item.id
            this.showTim = true
        },
        openAllcity() {
            this.popup.clist = this.userinfo.logistics_names
            this.popup.ischeckpop = true
        },
        openAllcitys(item) {
            this.popup.clist = item.logistics_names
            this.popup.ischeckpop = true
        },
        close() {
            this.popup.ischeckpop = false
        },
        //多层传递过来的 值关闭弹窗
        closeTim(e) {
            this.showTim = e
        }
    },
}
</script>
<style lang='scss' scoped>
.dialogs ::v-deep .el-dialog__body {
    padding: 12px 0px 0px 0px !important;
}

.dialogs ::v-deep .el-dialog__header {
    padding: 20px;
}

.check {
    display: flex;
    flex-wrap: wrap;

    .items {
        margin-right: 20px;
        margin-bottom: 20px;
    }
}

.contet {
    max-width: 1200px;
    margin: 0 auto;

    .dh {
        margin: 20px 0px;
    }

    .citem {
        display: flex;
        justify-content: space-between;
        box-sizing: border-box;
        margin-bottom: 10px;
        align-items: center;

        .c_l {
            .text_s {
                .gname {
                    font-family: PingFang SC, PingFang SC;
                    font-weight: 800;
                    font-size: 30px;
                    color: #000000;
                    line-height: 35px;

                    span {
                        font-family: DIN, DIN;
                        font-weight: bold;
                        font-size: 24px;
                        color: #FE1515;
                        line-height: 28px;
                        margin-left: 10px;
                    }
                }

                .tagflex {
                    display: flex;
                    font-family: PingFang SC, PingFang SC;
                    font-weight: 500;
                    font-size: 12px;
                    color: #666666;
                    line-height: 14px;
                    margin-top: 12px;

                    .titem {
                        padding: 2px 9px;
                        margin-right: 16px;
                    }

                    .i2 {
                        background: #EAF5FF;
                        color: #3D64FF;

                    }

                    .i3 {
                        background: #FFEBCE;
                        color: #E28400;

                    }
                }

                .dw {
                    display: flex;
                    align-items: center;
                    font-family: PingFang SC,
                        PingFang SC;
                    font-weight: 500;
                    font-size: 14px;
                    color: #000000;
                    line-height: 16px;
                    margin-top: 10px;

                    img {
                        width: 22px;
                        height: 22px;
                        margin-right: 8px;
                    }

                }

                .js {
                    font-family: PingFang SC, PingFang SC;
                    font-weight: 500;
                    font-size: 14px;
                    color: #000000;
                    line-height: 16px;
                    margin-top: 10px;
                    width: 900px;
                }

                .wl {
                    display: flex;
                    font-family: PingFang SC, PingFang SC;
                    font-weight: 500;
                    font-size: 14px;
                    line-height: 16px;
                    margin-top: 10px;

                    .wl_l {
                        color: #E38111;
                        display: flex;
                        align-items: center;
                    }

                    .open {
                        color: #298DF7;
                        margin-left: 8px;
                        cursor: pointer;
                    }

                }
            }
        }

        .c_r {
            cursor: pointer;
            width: 269px;
            background: #FFF9DA;
            border-radius: 6px 6px 6px 6px;
            padding: 14px 26px;
            box-sizing: border-box;

            .btn {
                border-radius: 6px 6px 6px 6px;
                display: flex;
                align-items: center;
                justify-content: center;
                font-family: PingFang SC, PingFang SC;
                font-weight: 800;
                font-size: 24px;
                color: #E28400;
                line-height: 28px;

                img {
                    width: 28px;
                    height: 28px;
                    margin-right: 6px;
                }
            }

            .btexts {
                font-family: PingFang SC, PingFang SC;
                font-weight: 500;
                font-size: 14px;
                color: #E28400;
                line-height: 16px;
                margin-top: 10px;
            }
        }
    }


    .conten_z {
        border-top: 1px solid #DEDEDE;
        margin-top: 30px;
        padding-top: 30px;

        .titl {
            display: flex;
            justify-content: space-evenly;

            .items {
                cursor: pointer;
                font-family: PingFang SC, PingFang SC;
                font-weight: bold;
                font-size: 24px;
                color: #ADAAAA;
                line-height: 28px;
            }

            .active {
                color: #000000;
            }

            .x {
                width: 38px;
                height: 4px;
                background: #FFDB0C;
                border-radius: 10px 10px 10px 10px;
                margin: 20px auto;
            }
        }

        .c_neir {
            margin-bottom: 30px;
            min-height: 500px;
        }
    }
}

.bcg {
    font-size: 0%;

    img {
        width: 100%;
        height: 200px;
    }
}


.content_list {
    max-width: 1200px;
    margin: 20px auto;

    .title {
        display: flex;
        align-items: center;
        margin: 0 auto;
        width: 180px;

        .tt {
            font-family: PingFang SC, PingFang SC;
            font-weight: bold;
            font-size: 24px;
            color: #000000;
            line-height: 28px;
            margin: 0 10px;
        }

        .x {
            width: 28px;
            height: 2px;
            background: #000000;
            border-radius: 12px 12px 12px 12px;
        }
    }

    .citem {
        display: flex;
        justify-content: space-between;
        padding: 20px 10px;
        box-sizing: border-box;
        border: 1px solid #FFFFFF;

        .c_l {
            display: flex;

            .imgs {
                width: 120px;
                height: 120px;
                border-radius: 6px;
            }

            .text_s {
                margin-left: 18px;
                display: flex;
                flex-direction: column;
                justify-content: space-between;

                .gname {
                    font-family: PingFang SC, PingFang SC;
                    font-weight: 500;
                    font-size: 16px;
                    color: #000000;
                    line-height: 19px;
                    text-align: left;

                    span {
                        font-family: DIN, DIN;
                        font-weight: bold;
                        font-size: 16px;
                        color: #FE1515;
                        line-height: 19px;
                        margin-left: 10px;
                    }
                }

                .tagflex {
                    display: flex;
                    font-family: PingFang SC, PingFang SC;
                    font-weight: 500;
                    font-size: 12px;
                    color: #666666;
                    line-height: 14px;

                    .titem {
                        padding: 2px 9px;
                        margin-right: 16px;
                    }

                    .i1 {
                        background: #F4F4F4;
                        color: #666666;
                    }

                    .i2 {
                        background: #EAF5FF;
                        color: #3D64FF;

                    }

                    .i3 {
                        background: #FFEBCE;
                        color: #E28400;

                    }
                }

                .js {
                    font-family: PingFang SC, PingFang SC;
                    font-weight: 500;
                    font-size: 14px;
                    color: #000000;
                    line-height: 16px;
                }

                .wl {
                    font-family: PingFang SC, PingFang SC;
                    font-weight: 500;
                    font-size: 14px;
                    color: #E38111;
                    line-height: 16px;
                    display: flex;
                    align-items: center;

                    .items {
                        margin-right: 6px;
                    }

                    .btn {
                        color: #298DF7;
                        cursor: pointer;
                    }
                }
            }
        }

        .c_r {
            display: flex;
            flex-direction: column;
            justify-content: space-between;

            .rig_icon {
                text-align: right;
                cursor: pointer;
            }

            .btn {
                cursor: pointer;
                width: 120px;
                height: 38px;
                background: #FFDB0C;
                border-radius: 6px 6px 6px 6px;
                display: flex;
                align-items: center;
                justify-content: center;
                font-family: PingFang SC, PingFang SC;
                font-weight: 500;
                font-size: 14px;
                color: #000000;
                line-height: 16px;

                img {
                    width: 24px;
                    height: 24px;
                    margin-right: 6px;
                }
            }
        }
    }

    .citem:hover {
        border: 1px solid #FF9500;
        cursor: pointer;
        border-radius: 6px;
    }
}
</style>